declare var window: any;

export const SSOValidations = function () {
  $(document).ready(function () {
    // custom rule: allow only valid domain names + wildcard subdomains
    $.validator.addMethod(
      "domainList",
      function (value: string) {
        if (!value) return false;

        let domains: string[] = [];
        try {
          // convert JSON array or split fallback
          domains = JSON.parse(value);
        } catch (e) {
          domains = value.split(/[\n,]+/);
        }

        // only valid domains (example.com, sub.example.com, *.example.com)
        const domainRegex = /^(\*\.)?[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;

        return domains.every((d) => domainRegex.test(d.trim()));
      },
      "Please enter valid domains (example.com, sub.example.com, *.example.com)"
    );

    $("#sso_setting_form").validate({
      rules: {
        name: {
          required: true,
        },
        whitelisted_domains: {
          required: true,
          domainList: true,
        },
      },
      messages: {
        name: {
          required: "Name is required",
        },
        whitelisted_domains: {
          required: "Domains are required",
          domainList:
            "Use valid domains only (e.g. example.com, sub.example.com, *.example.com)",
        },
      },
    });
  });
};
